import React from 'react';

const SignIn = React.lazy(() => import('./sign-in'));
const ForgotPassword = React.lazy(() => import('./forgot-password'));
const SetupAccount = React.lazy(() => import('./setup-account'));
const ResetPassword = React.lazy(() => import('./reset-password'));

export const authRouteConfig = [
  {
    path: '/sign-in',
    element: <SignIn />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/setup-account',
    element: <SetupAccount />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
];
